<div
  class="header"
  [class]="collapsedMenu() ? 'collapsed' : 'expanded'"
>
  <div class="left d-flex align-items-stretch">
    @if (headerData?.backPath) {
      <a
        class="back-btn d-flex"
        title="Back"
        [routerLink]="headerData?.backPath"
      >
        <i class="m-auto icon ic-arrow-left-20"></i>
      </a>
    }

    <div class="title-wrapper d-flex align-items-center gap-12">
      <i
        [class]="'icon ' + headerData?.iconClass"
        [hidden]="!headerData?.iconClass"
      ></i>

      <div>
        <div class="title" [hidden]="!headerData?.title">{{ headerData?.title }}</div>
        <div class="subtitle" [hidden]="!headerData?.subtitle">{{ headerData?.subtitle }}</div>
      </div>
    </div>
  </div>

  <div class="right">
    @if (logo()) {
      <a class="logo d-inline-block" routerLink="/settings">
        <img alt="logo" [attr.src]="logo()">
      </a>
    }

    @if (availableOrganisations().length > 1) {
      <div ngbDropdown class="dropdown organisations-dropdown">
        <div
          ngbDropdownToggle
          id="organisation-switch"
          class="organisation-select"
          [title]="organisationName()"
        >
          <div class="text">{{ organisationName() }}</div>
          <span class="icon ic-select-20"></span>
        </div>

        <div ngbDropdownMenu aria-labelledby="organisation-switch" class="common-dropdown-menu dropdown-menu">
          @for (org of availableOrganisations(); track org.organisationExternalId) {
            @if (organisationName() !== org.organisationName) {
              <button ngbDropdownItem class="dropdown-item" (click)="changeOrganization(org.organisationExternalId)">
                <span>
                  {{ org.organisationName }}
                </span>
              </button>
            }
          }
        </div>
      </div>
    }

    <div class="divider"></div>

    <div class="action-container">
      @if ((alerts$ | async)?.length) {
        <div ngbDropdown #dropdown="ngbDropdown" class="dropdown">
          <button ngbDropdownToggle class="action-btn" data-toggle="dropdown">
            <i class="icon ic-bell-20"></i>
            <div class="bell indicator" [class]="{red: !(greenAlert$ | async), green: (greenAlert$ | async)}"></div>
          </button>

          <div
            ngbDropdownMenu
            class="dropdown-menu bell-menu dropdown-menu-right"
          >
            @for (alert of (alerts$ | async); track $index) {
              <div
                class="info-item-container"
                [class]="{'unread': !alert.isRead}"
                (click)="displayAlert(alert.id); dropdown.close()"
              >
                <div class="info-item-wrapper">
                  <div class="info-item">{{ alert.modelDetailTitle }}</div>
                  <div class="info-item date">{{ alert.createdOn | date: 'dd MMM yyyy HH:mm' }}</div>
                </div>

                <div
                  class="indicator"
                  [class]="{
                     red: alert.indicator === 'red',
                     green: alert.indicator === 'green'
                  }"
                ></div>
              </div>

              <app-divider/>
            }

            <div class="display-all">
              <a
                class="btn btn-secondary d-block"
                [routerLink]="['/alerts', 'inbox']"
                (click)="dropdown.close()"
              >
                See all alerts
              </a>
            </div>
          </div>
        </div>
      }

      <div ngbDropdown class="dropdown">
        <button ngbDropdownToggle class="action-btn" data-toggle="dropdown">
          <i class="icon ic-my-account-20"></i>
        </button>

        <div ngbDropdownMenu class="dropdown-menu dropdown-menu-right">
          <!-- <div class="dropdown-item"><a class="dropdown-button">My account</a></div>-->
          <!-- <div class="dropdown-item"><a class="dropdown-button">Business settings</a></div>-->
          <!-- <div class="dropdown-item"><a class="dropdown-button">Change password</a></div> -->
          <div class="dropdown-item"><a class="dropdown-button text-gray900" routerLink="/settings/my-organisation">Organisation
            Details</a></div>
          <div class="dropdown-item"><a class="dropdown-button" (click)="logOut()">Log out</a>
          </div>
        </div>
      </div>

      <!--      <button class="action-btn" (click)="help()">-->
      <!--        <i class="icon ic-help-circle-20"></i>-->
      <!--      </button>-->

      <button class="action-btn" (click)="logOut()">
        <i class="icon ic-log-out-20"></i>
      </button>
    </div>
  </div>
</div>
